import type { SxProps, Theme } from "@mui/material/styles";

/** Theme spacing units for the dashboard column (navbar + page share this). */
export const PAGE_LAYOUT_GUTTER = 1;

/** Top + bottom DashboardLayout padding in px (`PAGE_LAYOUT_GUTTER` × 8 × 2). */
export const PAGE_LAYOUT_PADDING_Y_PX = PAGE_LAYOUT_GUTTER * 8 * 2;

/**
 * Inner panel for list/detail pages: full column width with tight inner padding.
 */
export const listPageContainerSx: SxProps<Theme> = {
  backgroundColor: (t) => t.palette.background.section,
  borderRadius: 1,
  p: { xs: 1, sm: 1.25 },
  m: 0,
  width: "100%",
  minWidth: 0,
};

/** Root Paper for DataGrid tables that should fill their parent section. */
export const fillDataTableRootSx: SxProps<Theme> = {
  borderRadius: 1.5,
  overflow: "hidden",
  width: "100%",
  minWidth: 0,
  flex: 1,
  minHeight: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

/** Wrapper around DataGrid so the grid (not autoHeight) consumes leftover space. */
export const fillDataTableGridWrapSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  width: "100%",
  bgcolor: "background.paper",
};

export const fillDataGridSx: SxProps<Theme> = {
  border: 0,
  height: "100%",
  width: "100%",
};
